"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PersonalCard = void 0;
var _icons = require("@ori-ui/icons");
var _NoUserImage = _interopRequireDefault(require("./NoUserImage"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Personal info card displayed for example in OOB order detail.
 * @param props PersonalCardProps
 * @returns JSX.Element
 */
const PersonalCard = ({
  addressData,
  className,
  email,
  label,
  phone,
  testId,
  userImageAlt,
  userImageSrc
}) => {
  const ownerState = {
    isOnlyFirstRow: addressData.length === 1
  };
  const addressWrapperProps = {
    ownerState
  };
  const userIconProps = {
    alt: userImageAlt,
    errorFallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoUserImage.default, {}),
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoUserImage.default, {}),
    ownerState,
    shouldThrowError: false,
    src: userImageSrc ?? ''
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": testId,
    children: [label ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Label, {
      variant: "h6",
      children: label
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AddressWrapper, {
      ...addressWrapperProps,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.UserIcon, {
        ...userIconProps
      }), addressData.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AddressRow
      // eslint-disable-next-line react/no-array-index-key -- no better key data available
      , {
        color: "textPrimary",
        fontWeight: index === 0 ? 'bold' : 'normal',
        variant: "body1",
        children: item
      }, `${item}-${index}`))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContactsWrapper, {
      children: [phone ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContactsRow, {
        color: "textPrimary",
        variant: "body1",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Telephone, {
          fontSize: "small"
        }), phone]
      }) : null, email ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContactsRow, {
        color: "textPrimary",
        variant: "body1",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Email, {
          fontSize: "small"
        }), email]
      }) : null]
    })]
  });
};
exports.PersonalCard = PersonalCard;
var _default = exports.default = PersonalCard;
//# sourceMappingURL=PersonalCard.js.map